"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeStep = removeStep;
const dist_1 = require("../../fs/dist");
/** Remove a pending step. Returns the updated plan and the ids of the steps whose
 *  `blockedBy` referenced the removed step (those references are stripped — no
 *  dangling blocker). The report is computed from the pre-removal state, which the
 *  pure reducer strips exactly. */
async function removeStep(input, deps) {
    const weaveId = await (0, dist_1.resolveWeaveIdForPlan)(deps.loomRoot, input.planId);
    const weave = await deps.loadWeave(deps.loomRoot, weaveId);
    const plan = weave.threads.flatMap((t) => t.plans).find((p) => p.id === input.planId);
    if (!plan) {
        throw new Error(`Plan '${input.planId}' not found in weave '${weaveId}'`);
    }
    // Which surviving steps reference the removed step as a blocker? Their references
    // will be stripped by the reducer; report them so the caller can re-thread deps.
    const strippedBlockers = plan.steps
        .filter((s) => s.id !== input.stepId && Array.isArray(s.blockedBy) && s.blockedBy.includes(input.stepId))
        .map((s) => s.id);
    await deps.runEvent(weaveId, { type: 'REMOVE_STEP', planId: input.planId, stepId: input.stepId });
    const updatedWeave = await deps.loadWeave(deps.loomRoot, weaveId);
    const updatedPlan = updatedWeave.threads.flatMap((t) => t.plans).find((p) => p.id === input.planId);
    return { plan: updatedPlan, strippedBlockers };
}
